import { WorkflowActionTypes } from '../Enums/workflow-action-types';
import { SendMailActionData } from './datas/send-mail-action-data';
import { UpdateAttributeActionData } from './datas/update-attribute-action-data';

export class RestApiAction {
    public id: number;
    public organizationId: string;
    public viewId: number;
    public restApiConfigurationId: number;
    public name: string;
    public description: string;
    public updateDate: Date;
    public type: WorkflowActionTypes;
    public order: number;
    public actionData: object;

    private _sendMailActionData: SendMailActionData;
    private _updateAttributeActionData: UpdateAttributeActionData;

    public get sendMailActionData() {
        if (this.type != WorkflowActionTypes.SendMail) {
            return null;
        }

        if (this.actionData !== null) {
            this._sendMailActionData = this.actionData as SendMailActionData;
        } else {
            this._sendMailActionData = new SendMailActionData();
        }

        return this._sendMailActionData;
    }

    public get updateAttributeActionData() {
        if (this.type != WorkflowActionTypes.UpdateAttribute) {
            return null;
        }

        if (this.actionData !== null) {
            this._updateAttributeActionData = this.actionData as UpdateAttributeActionData;
        } else {
            this._updateAttributeActionData = new UpdateAttributeActionData();
        }

        return this._updateAttributeActionData;
    }

    public set sendMailActionData(value: SendMailActionData) {
        this.actionData = value;
    }

    public set updateAttributeActionData(value: UpdateAttributeActionData) {
        this.actionData = value;
    }
    /**
     * Retourne une copie d'une instance de RestApiAction
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: RestApiAction) {
        if (!!other) {
            const instance = new RestApiAction();

            instance.id = other.id;
            instance.organizationId = other.organizationId;
            instance.viewId = other.viewId;
            instance.restApiConfigurationId = other.restApiConfigurationId;
            instance.name = other.name;
            instance.description = other.description;
            instance.updateDate = other.updateDate;
            instance.type = other.type;
            instance.order = other.order;
            instance.actionData = other.actionData;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de RestApiAction
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: RestApiAction[]) {
        if (!!others) {
            let actions: RestApiAction[] = [];

            others.forEach((x) => {
                const action = RestApiAction.clone(x);
                actions.push(action);
            });

            return actions;
        } else {
            return [];
        }
    }
}
